import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../../dynamicFormBuilder/FormField'
import { AdditionalLayout, BackOrderLayout, CommentLayout, UserDefinedLayout } from './Layout';

function BackOrderTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});


    const handleAdditionalFormLoad = useCallback(() => {

    }, []);
    const handleFieldChange = useCallback((name, value, e) => {

    }, []);
    const handleSelectionChange = useCallback((name, value, e) => {

    }, []);

    return (
        
        <div className="FormMt" style={{ height: '100%', overflow: 'auto' }}>
            <FormField
                currrentUser={currentUser}
                layoutId='8FE95E74-7E2A-4F11-9AF4-A171FE417F82'
                layoutName='OMDetailsBackOrdrForm'
                defaultFormSchema={BackOrderLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleAdditionalFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(BackOrderTab);
